function r(n, e) {
  const t = n.key;
  for (; e; ) {
    if (e.key === t)
      return !0;
    e = e.parent;
  }
  return !1;
}
export {
  r as contains
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/treemate@0.3.11/~/treemate/es/contains.js
// module id = 1730
// module chunks = 41